import React, { useEffect } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomerAnalyticsReport from "./CustomerAnalyticsReport";
import OutletSalesReport from "./OutletSalesReport";
import SalesOverviewReport from "./SalesOverviewReport";
import SalesTargetReport from "./SalesTargetReport";
import SalesDashboard from "./SalesDashboard";
import { TabPanel, TabView } from "primereact/tabview";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function SalesReport({ history }) {
  const { reload } = useGlobalData();
  useEffect(() => {}, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Sales Reports"
        breadcrumbs={[
          { page: "/reports", title: "Reports", active: false },
          {
            page: "/sales/sales-reports",
            title: "Sales Reports",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/reports");
            },
          },
        ]}
      />
      <ContentLayout>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="tabview">
              <div className="card">
                <TabView
                  renderActiveOnly={false}
                  className="tabview"
                  scrollable
                >
                  <TabPanel
                    header="Sales Dashboard"
                    rightIcon="fas fa-chart-area"
                  >
                    <SalesDashboard />
                  </TabPanel>
                  <TabPanel
                    header="Sales Overview"
                    rightIcon="fas fa-search-dollar"
                  >
                    <SalesOverviewReport />
                  </TabPanel>
                  <TabPanel
                    header="Customer Analytics"
                    rightIcon="fas fa-chart-bar"
                  >
                    <CustomerAnalyticsReport />
                  </TabPanel>
                  <TabPanel header="Outlet Sales" rightIcon="fas fa-store">
                    <OutletSalesReport />
                  </TabPanel>

                  <TabPanel header="Sales Target" rightIcon="fas fa-crosshairs">
                    <SalesTargetReport />
                  </TabPanel>
                </TabView>
              </div>
            </div>
          </div>
        </div>
      </ContentLayout>
    </React.Fragment>
  );
}

export default SalesReport;
